import { Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Pluralize from 'pluralize';
import { isEnquiryOption, openEnquiry } from './helpers';
import PriceDefinition from './price_definition';
import { optionShape, subOptionGroupShape, subOptionShape } from './prop_types';

const SubOptionCard = ({ option, subOption, subGroup }) => {
  const history = useHistory();
  const isEnquiry = isEnquiryOption(subOption);
  const qtConfigOptionTitle =
    subGroup.type === 'accommodation-option-group'
      ? `${option.title} - ${subGroup.title} - ${subOption.title}`
      : `${option.title} - ${subOption.title}`;
  const handleRedirect = () => {
    if (isEnquiry) {
      openEnquiry(subOption.title, qtConfigOptionTitle);
    } else {
      history.push('/booking-form', {
        bookableOption: subOption,
        option,
        subGroup,
      });
    }
  };

  let buttonText = 'Book';
  if (isEnquiry) {
    buttonText = 'Enquire';
  } else if (subGroup.enquiry_options_only) {
    buttonText = 'View options';
  }

  return (
    <Card className="booking-option-card my-4">
      <Card.Body className="d-flex">
        <div className="w-100">
          <Card.Title className="title-wrap">
            <h5 className="reset-text fw-bold fs-4 mb-2 text-secondary">
              {subOption.title}
            </h5>
            <h6 className="reset-text fw-bold mb-3 text-tertiary">
              {subOption.price}
            </h6>
          </Card.Title>
          <PriceDefinition list={subOption.price_definition} />
          {subOption.room_capacity && (
            <div className="option-description reset-text">
              Max {subOption.room_capacity}{' '}
              {Pluralize('person', subOption.room_capacity)} per room
            </div>
          )}
        </div>
        <div>
          <button
            type="button"
            onClick={handleRedirect}
            className="btn btn-primary w-100 mt-4"
          >
            {buttonText}
          </button>
        </div>
      </Card.Body>
    </Card>
  );
};

SubOptionCard.propTypes = {
  option: optionShape,
  subOption: subOptionShape,
  subGroup: subOptionGroupShape,
};

export default SubOptionCard;
